import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { postsMessages } from './postsMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Posts.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostsLaneProps {
  title: string;
  /** The class of the state pill (`pillReady`, `pillScheduled`, `pillPosted`). */
  pillClass: string | undefined;
  count: number;
  /** The link on the right of the head ("Plan them", "Open Calendar", "Open in Social"). */
  headAction?: React.ReactNode;
  /** The one quiet line of an empty lane (design d2). */
  emptyText: string;
  /** Rows hidden behind "Show N more"; 0 hides the button. */
  hiddenCount: number;
  isExpanded: boolean;
  onToggleMore: () => void;
  /** Under 576 px only the lane of the segmented control shows (design c3). */
  isHiddenOnPhone: boolean;
  testId: string;
  children: React.ReactNode;
}

/** One lane of the board (design assets-rethink c1 `.ln`): the head, the rows, "Show N more". */
const PostsLaneComponent: React.FC<PostsLaneProps> = (props) => {
  const {
    title,
    pillClass,
    count,
    headAction,
    emptyText,
    hiddenCount,
    isExpanded,
    onToggleMore,
    isHiddenOnPhone,
    testId,
    children,
  } = props;
  const intl = useIntl();
  return (
    <section className={clsx(styles.lane, isHiddenOnPhone && styles.laneHidden)} data-testid={testId}>
      <div className={styles.laneHead}>
        <span className={clsx(styles.pill, pillClass)}>{title}</span>
        <span className={styles.eyebrow}>{intl.formatNumber(count)}</span>
        <span className={styles.grow} />
        {headAction}
      </div>
      <div className={styles.laneBody}>
        {count === 0 ? <div className={styles.laneEmpty}>{emptyText}</div> : children}
      </div>
      {(hiddenCount > 0 || isExpanded) && (
        <div className={styles.laneFoot}>
          <button type="button" className={styles.link} onClick={onToggleMore}>
            {isExpanded
              ? intl.formatMessage(postsMessages.showLess)
              : intl.formatMessage(postsMessages.showMore, { count: hiddenCount })}
          </button>
        </div>
      )}
    </section>
  );
};

export const PostsLane = TypedMemo(PostsLaneComponent);
